var React = require('react');

function Filter (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor"},[React.createElement("rect",{"y":"3","width":"24","height":"1.5","key":0}),React.createElement("rect",{"y":"19","width":"24","height":"1.5","key":1}),React.createElement("rect",{"y":"11","width":"22","height":"1.5","key":2}),React.createElement("circle",{"cx":"7.75","cy":"3.75","r":"2.75","key":3}),React.createElement("circle",{"cx":"21.25","cy":"11.75","r":"2.75","key":4}),React.createElement("circle",{"cx":"4.75","cy":"19.75","r":"2.75","key":5})]));
}

Filter.defaultProps = {"viewBox":"0 0 24 24","fill":"none","style":{"color":"#019FCB"}};

module.exports = Filter;

Filter.default = Filter;
